"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //      


var _mapboxGl = require("mapbox-gl");

var _mapboxGl2 = _interopRequireDefault(_mapboxGl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Map using the mapbox backend
 *
 * @param {string} apiKey The api key used by the map
 * @param {string} containerId The container id where the map will be drawn
 * @param {string} styleId The style id that will be used to draw the map
 */
var Map = function () {
	function Map(options) {
		_classCallCheck(this, Map);

		this.options = options;
		this.isInitialized = false;
		this.isLoaded = false;
	}

	/**
  * Creates the map
  *
  * @returns A Promise when the map has been loaded
  */


	_createClass(Map, [{
		key: "create",
		value: function create() {
			var _this = this;

			return new Promise(function (resolve, reject) {

				if (_this.options.container !== "") {

					_this.mapCreate(resolve, reject);
				} else {

					reject(new Error("Container id not set"));
				}
			});
		}

		/**
   * Creates the map object. Implementation specific
   *
   * @param {function} resolve The function to call when the map creation succeeds
   * @param {function} reject The function to call when the map creation fails
   */

	}, {
		key: "mapCreate",
		value: function mapCreate(resolve, reject) {

			throw new Error("Map::mapCreate function must be implemented by its subclasses");
		}

		/**
   * Function called when the map has finished loading. Subclasses must call it before
   * setting any data
   *
   */

	}, {
		key: "mapHasLoaded",
		value: function mapHasLoaded() {

			this.isLoaded = true;
		}

		/**
   * Removes the map from the element
   */

	}, {
		key: "remove",
		value: function remove() {

			if (this.isInitialized) this.mapRemove();
		}

		/**
   * Removes the map object. Implementation specific
   */

	}, {
		key: "mapRemove",
		value: function mapRemove() {

			throw new Error("Map::removeMap function must be implemented by its subclasses");
		}

		/**
   * Sets the map options
   *
   * @param {MapOptions} options
   */

	}, {
		key: "setOptions",
		value: function setOptions(options) {

			this.options = options;
		}

		/**
   * Sets the data to draw
   *
   * @param {MapData} data
   */

	}, {
		key: "setData",
		value: function setData(data) {

			if (this.isLoaded) {

				this.removeMapData();
				this.addMapData(data);
			} else {

				throw new Error("Map not yet loaded");
			}
		}

		/**
   * Adds data to draw to the existing data
   *
   * @param {MapData} data
   */

	}, {
		key: "addData",
		value: function addData(data) {

			if (this.isLoaded) {

				this.addMapData(data);
			} else {

				throw new Error("Map not yet loaded");
			}
		}

		/**
   * Adds data to draw to the existing data. Implementation specific
   *
   * @param {MapData} data
   */

	}, {
		key: "addMapData",
		value: function addMapData(data) {

			throw new Error("Map::addMapData function must be implemented by its subclasses");
		}

		/**
   * Removes all the data from the map. Implementation specific
   *
   */

	}, {
		key: "removeMapData",
		value: function removeMapData() {

			throw new Error("Map::removeMapData function must be implemented by its subclasses");
		}

		/**
   * Subscribe to a map event that happens on a layer
   *
   * @param {string} eventName The event name
   * @param {string} layerName The layer name
   * @param {Function} callback The callback to run when the event arrives
   */

	}, {
		key: "subscribe",
		value: function subscribe(eventName, layerName, callback) {

			throw new Error("Map::subscribe function must be implemented by its subclasses");
		}

		/**
   * AddControl to map map
   *
   * @param {string} controlName The event name
   * @param {object} controlOptions The layer name
   *
   */

	}, {
		key: "addControlMap",
		value: function addControlMap(controlName, controlOptions) {

			throw new Error("Map::addControl function must be implemented by its subclasses");
		}
	}, {
		key: "fitBounds",
		value: function fitBounds(bounds) {

			throw new Error("Map::fitBounds function must be implemented by its subclasses");
		}
	}, {
		key: "getZoom",
		value: function getZoom() {

			throw new Error("Map::getZoom function must be implemented by its subclasses");
		}
	}, {
		key: "easeTo",
		value: function easeTo(options) {

			throw new Error("Map::easeTo function must be implemented by its subclasses");
		}
	}, {
		key: "getPaintProperty",
		value: function getPaintProperty(layerid, property) {

			throw new Error("Map::getPaintProperty function must be implemented by its subclasses");
		}
	}, {
		key: "getStyle",
		value: function getStyle() {

			throw new Error("Map::getStyle function must be implemented by its subclasses");
		}
	}, {
		key: "getMap",
		value: function getMap() {
			return this.map;
		}
	}]);

	return Map;
}();

module.exports = Map;
